import {
  stringLength,
  createValidator
} from 'app/validators/base'

const validate = stringLength({ min: 1 }, value => value.trim())

export default createValidator(validate, 'firstName')
